// src/components/RequestStatus/ApprovedLeaves.js
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  Spinner,
  Alert,
  Badge,
  Pagination,
  Button,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { io } from "socket.io-client";
import ApprovedLeavesInfoModal from "./ApprovedLeavesInfoModal";
import { FaTimesCircle } from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || API_URL;

// Assign a border color per leave type (use green for any custom types)
const BORDER_COLORS = {
  Vacation: "#4da6ff",
  Sick: "#ff6666",
  Personal: "#ffcc66",
  "CI/CO Correction": "#008000",
  "Planned Leave": "#008000",
  "Unplanned Leave": "#008000",
  "Work From Home Request": "#008000",
  Compup: "#008000",
  Other: "#008000",
};

export default function ApprovedLeaves({
  fetchApprovedRequests,
  loading,
  error,
  currentPage,
  setAllData,
  allData,
  setCurrentPage,
}) {
  const storedUser = JSON.parse(localStorage.getItem("user")) || {};
  const currentAdminName = storedUser.name || "Admin";
  const myEmail = (storedUser.email || "").toLowerCase();
  const [showModal, setShowModal] = useState(false);
console.log('storedUser',storedUser)
  const [selectedCard, setSelectedCard] = useState(null);

  const [data, setData] = useState([]);
  const [showMine, setShowMine] = useState(true);
  const [leaveType, setLeaveType] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");
  const [processing, setProcessing] = useState(new Set());
  const itemsPerPage = 9;
  const socketRef = useRef(null);
  const totalPages = useMemo(() => {
    return Math.ceil(data.length / itemsPerPage);
  }, [data.length, itemsPerPage]);

  const leaveTypes = [
    "All",
    "Attendance CI/CO Correction",
    "Planned Leave",
    "Unplanned Leave",
    "Work From Home Request",
    "Compup",
  ];
  // const fetchApprovedRequests = useCallback(async () => {
  //   setLoading(true);
  //   setError(null);

  //   axios
  //     .get(`${API_URL}/api/approved-requests`)
  //     .then((res) => {
  //       const arr = Array.isArray(res.data) ? res.data : [];

  //       const sorted = arr.sort(
  //         (a, b) => new Date(b.created_at) - new Date(a.created_at)
  //       );
  //       setAllData(sorted);
  //       setData(sorted);

  //       setCurrentPage(1);
  //     })
  //     .catch(() => setError("Failed to load approved requests"))
  //     .finally(() => setLoading(false));
  // }, []);
  // Fetch approved requests once on mount
  useEffect(() => {
    fetchApprovedRequests();
  }, [fetchApprovedRequests]);

  // Real-time socket listener
  useEffect(() => {
    socketRef.current = io(SOCKET_URL);

    socketRef.current.on("requestDecision", (payload) => {
      if (payload.decision !== "approved") return;

      const toMatch = payload.to_email.toLowerCase() === myEmail;
      const ccList = payload.cc_email
        ? payload.cc_email.split(/[,;]+/).map((e) => e.trim().toLowerCase())
        : [];

      if (!toMatch && !ccList.includes(myEmail)) return;

      const newRow = {
        request_id: payload.requestId,
        employee_id: payload.employee_id,
        from_name: payload.from_name,
        to_email: payload.to_email,
        cc_email: payload.cc_email || "",
        subject: payload.subject,
        leave_type: payload.leave_type,
        created_at: payload.timestamp,
      };

      setAllData((prev) =>
        [newRow, ...prev].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        )
      );
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, [myEmail, setAllData]);

  // filters
  useEffect(() => {
    let temp = allData;
    
    if (showMine && storedUser.role != 4) {
      temp = temp.filter((r) => {
        console.log(r.to_email.toLowerCase() === myEmail)
        const toMatch = r.to_email.toLowerCase() === myEmail;
        const ccs = r.cc_email
          ? r.cc_email.split(/[,;]+/).map((e) => e.trim().toLowerCase())
          : [];
        return toMatch || ccs.includes(myEmail);
      });
    }
    if (leaveType !== "All")
      temp = temp.filter((r) => r.leave_type === leaveType);
    if (searchTerm.trim()) {
      const q = searchTerm.trim().toLowerCase();
      temp = temp.filter(
        (r) =>
          r.subject.toLowerCase().includes(q) ||
          r.from_name.toLowerCase().includes(q)
      );
    }
    if (filterDate) {
      const start = new Date(filterDate);
      start.setHours(0, 0, 0, 0);
      const end = new Date(filterDate);
      end.setHours(23, 59, 59, 999);
      temp = temp.filter((r) => {
        const d = new Date(r.created_at);
        return d >= start && d <= end;
      });
    }

    setData(temp);

    // ✅ Reset to first page only when filters actually change
    if (showMine || leaveType !== "All" || searchTerm || filterDate) {
      setCurrentPage(1);
    }
  }, [allData, showMine, leaveType, searchTerm, filterDate, myEmail]);

  const handleSendEmail = useCallback(async () => {
    if (!selectedCard) return;

    setModalLoading(true);
    setProcessing(prev => new Set(prev).add(selectedCard.request_id));

    try {


      const response = await axios.post(`${API_URL}/api/approved-to-reject`, {
        request_id: selectedCard.request_id,
        subject: emailSubject,
        body: emailBody,
        empName: selectedCard.from_name,
        employeeId: selectedCard.employee_id,
        leaveType: selectedCard.leave_type,
        createdAt: selectedCard.created_at,
        leave_dates: selectedCard.leave_dates,
        leave_day_types: selectedCard.leave_day_types,
        leave_days:selectedCard.leave_days,
        total_leave_days:selectedCard.total_leave_days,
        leave_date:selectedCard.leave_date
      });

      if (response.status === 200) {
        toast.success("Request rejected and email sent");
        setEmailModalVisible(false);
        setSelectedCard(null);
        await fetchApprovedRequests();
      }
    } catch (err) {
      console.error("Error processing request:", err);

      // GUARANTEED toast visible
      toast.error(err?.response?.data?.message || "Failed to process request");
    } finally {
      setProcessing(prev => {
        const copy = new Set(prev);
        copy.delete(selectedCard.request_id);
        return copy;
      });
      setModalLoading(false);
    }
  }, [
    selectedCard, emailSubject, emailBody, fetchApprovedRequests
  ]);


  if (loading)
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner />
      </div>
    );
  if (error)
    return (
      <Alert variant="danger" className="mt-4 text-center">
        {error}
      </Alert>
    );


  const startIdx = (currentPage - 1) * itemsPerPage;
  const slice = data.slice(startIdx, startIdx + itemsPerPage);

  const handleModal = (data) => {
    setShowModal(true);
    setSelectedCard(data);
  };

  const handleCorrection = async () => {
    await correctionRequest();
    await fetchApprovedRequests();
  };

  const correctionRequest = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/correction-request`, {
        request_id: selectedCard.request_id,
      });

      if (response.status === 200) {
        toast.success("Correction request sent successfully!");
        await fetchApprovedRequests();
      }
    } catch (error) {
      if (error.status === 404) {
        return;
      }
      toast.error("Something went wrong");

      console.error("Error sending correction request:", error);
    }
  };

  const prepareEmailTemplate = (req, decision) => {
    // const subj = `Leave Request #${req.request_id} ${
    //   decision === "approved" ? "Approved" : "Not Approved"
    // }`;
    const subj = req.subject;
    const decisionText = "not approved";
    const body =
      `Hello ${req.from_name},\n\n` +
      `Your ${req.leave_type} request submitted on ${new Date(
        req.created_at
      ).toLocaleDateString()} has been ${decisionText} by ${currentAdminName}.\n\n` +
      `Best regards,\n${currentAdminName}`;
    return { subj, body };
  };

  const openEmailEditor = (decision) => {
    if (!selectedCard) return;
    const { subj, body } = prepareEmailTemplate(selectedCard, decision);

    setEmailModalVisible(true)
    setShowModal(false)
    // setDecisionType(decision);
    setEmailSubject(subj);
    setEmailBody(body || '');
    // setSaveEmail(selected.body)
    // setEmailModalVisible(true);
  };


  return (
    <div className="py-3">
      {/* Filters */}
      <Row className="align-items-center mb-3 gx-2">
        <Col xs="auto" className="mb-3">
          <Button
            variant={showMine ? "outline-secondary" : "primary"}
            onClick={() => setShowMine(!showMine)}
          >
            {showMine ? "Show All Requests" : "Show My Requests"}
          </Button>
        </Col>
        <Col xs={12} sm={4} md={3} className="mb-3">
          <Form.Select
            value={leaveType}
            onChange={(e) => setLeaveType(e.target.value)}
          >
            {leaveTypes.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs={12} sm={4} md={3} className="mb-3">
          <InputGroup>
            <Form.Control
              type="date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
            />
            {filterDate && (
              <Button
                variant="outline-secondary"
                onClick={() => setFilterDate("")}
              >
                Clear
              </Button>
            )}
          </InputGroup>
        </Col>
        <Col xs className="mb-3">
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search by name or subject…"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <Button
                variant="outline-secondary"
                onClick={() => setSearchTerm("")}
              >
                Clear
              </Button>
            )}
          </InputGroup>
        </Col>
      </Row>

      {/* Cards or empty */}
      {slice.length > 0 ? (
        <Row className="g-3">
          {slice.map((r, idx) => {
            const color = BORDER_COLORS[r.leave_type] || BORDER_COLORS.Other;
            const time = new Date(r.created_at).toLocaleString();
            const num = startIdx + idx + 1;

            return (
              <Col key={idx + 1} xs={12} md={6} lg={4}>
                <Card
                  onClick={() => handleModal(r)}
                  className="h-100 position-relative shadow-sm"
                  style={{
                    borderLeft: `6px solid ${color}`,
                    cursor: "pointer",
                    transition: "transform 0.1s ease-in-out",
                    paddingTop: "0.5rem",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.02)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <Badge
                    bg="light"
                    text="dark"
                    className="position-absolute"
                    style={{
                      top: "0.5rem",
                      left: "0.5rem",
                      fontSize: "0.75rem",
                      padding: "0.25em 0.5em",
                    }}
                  >
                    {r.is_corrected === "no" ? (
                      <span className="bg-danger text-white px-2 rounded">
                        # {num}
                      </span>
                    ) : (
                      `#${num}`
                    )}
                  </Badge>
                  <Card.Body className="pt-4 pb-2 px-3">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <Badge bg="success">{r.leave_type}</Badge>
                      <small
                        className="text-muted"
                        style={{ fontSize: "0.75rem" }}
                      >
                        {time}
                      </small>
                    </div>
                   <Card.Title className="mb-1" style={{ fontSize: "1rem" }}>
                                        {r.from_name}
                                      </Card.Title>
                          <Card.Text
                                          className="mb-1"
                                          style={{ fontSize: "0.875rem" }}
                                        >
                                          <strong>To:</strong> {r.to_email}
                                        </Card.Text>
                    {r.cc_email && (
                      <Card.Text style={{ fontSize: ".875rem" }}>
                        <strong>CC:</strong> {r.cc_email}
                      </Card.Text>
                    )}
                    <Card.Subtitle
                      className="text-truncate mb-1"
                      style={{ maxWidth: "100%", fontSize: ".875rem" }}
                    >
                      <strong>Subject:</strong> {r.subject}
                    </Card.Subtitle>
                    <Card.Text
                      style={{
                        height: "1.2rem",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: ".875rem",
                      }}
                    >
                      <strong>{r.body && "Body: "}</strong>
                      {r.body ? (
                        <>
                          {r.body.slice(0, 50)}
                          {r.body.length > 50 && "..."}
                        </>
                      ) : undefined}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <Alert variant="info" className="mt-4 text-center">
          {showMine
            ? "No approved requests matching your filters."
            : "No approved requests matching these filters."}
        </Alert>
      )}

      {/* Pagination */}
      {totalPages > 1 && (() => {
        const maxVisible = 5; // show only 5 pages at a time
        const startPage = Math.floor((currentPage - 1) / maxVisible) * maxVisible + 1;
        const endPage = Math.min(startPage + maxVisible - 1, totalPages);

        const pageNumbers = [];
        for (let i = startPage; i <= endPage; i++) {
          pageNumbers.push(i);
        }

        return (
          <Pagination className="justify-content-center mt-4">
            <Pagination.First
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            />
            <Pagination.Prev
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            />

            {pageNumbers.map((page) => (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </Pagination.Item>
            ))}

            <Pagination.Next
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            />
            <Pagination.Last
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        );
      })()}

      {showModal && (
        <ApprovedLeavesInfoModal
          selectedCard={selectedCard}
          isOpen={showModal}
          handleCorrection={handleCorrection}
          isClose={() => setShowModal(false)}
          rejectModalOpen={() => openEmailEditor(selectedCard)}
        />
      )}

      <Modal
        show={emailModalVisible}
        onHide={() => setEmailModalVisible(false)}
        centered
        size="md"
      >
        <Modal.Header className="py-2">
          <Modal.Title className="fs-6 d-flex align-items-center">
            <>
              <FaTimesCircle className="me-2 text-danger" />
              Reject Request
            </>

          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-2">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Subject</Form.Label>
              <Form.Control
                type="text"
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
                size="sm"
                className="border"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label className="small fw-semibold">Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                value={emailBody}
                onChange={(e) => setEmailBody(e.target.value)}
                size="sm"
                className="border"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="py-2">
          <div className="d-flex gap-2 w-100">
            <Button
              variant="outline-secondary"
              onClick={() => setEmailModalVisible(false)}
              disabled={modalLoading}
              size="sm"
              className="flex-grow-1"
            >
              Cancel
            </Button>
            <Button
              variant={"danger"}
              onClick={handleSendEmail}
              disabled={modalLoading}
              size="sm"
              className="flex-grow-1 d-flex align-items-center justify-content-center"
            >
              {modalLoading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" style={{ width: '1rem', height: '1rem' }} />
                  Sending...
                </>
              ) : (
                "Send Email"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <ToastContainer />
    </div>
  );
}
